import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Logo } from "../components/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("aus_token", data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const cls = "w-full bg-ink-900 border border-line text-white placeholder-white/35 focus:border-orange focus:outline-none focus:ring-1 focus:ring-orange px-4 py-3";

  return (
    <div className="min-h-screen bg-ink-900 flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="flex justify-center"><Logo /></div>
        <div className="mt-8 border border-line bg-ink-800 p-8">
          <h1 className="font-head font-black uppercase tracking-tight text-2xl">Admin Login</h1>
          <p className="mt-1 text-white/50 text-sm">Manage portfolio projects & quote requests.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
            <input data-testid="login-email" className={cls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input data-testid="login-password" className={cls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <button data-testid="login-submit" disabled={loading} className="w-full flex items-center justify-center gap-2 bg-orange hover:bg-orange-hover disabled:opacity-60 text-white font-head font-bold uppercase tracking-wide px-8 py-3 transition-colors">
              {loading && <Loader2 className="animate-spin" size={18} />} Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
